/*
 * Служебный браузер.
 *
 * Руководитель открывает сайт по адресу с `?bb_internal=1` один раз в каждом
 * своём браузере. С этого момента браузер считается служебным: его прошлая
 * история отзывается тем же путём, что и отказ от статистики, новые заходы не
 * учитываются, а вопрос о согласии больше не задаётся. 23.09.2026 на .com 25
 * сеансов из 27 пришли из одного браузера — собственные заходы составляли
 * большинство «посетителей».
 *
 * `?bb_internal=0` снимает отметку. Метка из адреса убирается сразу, чтобы её
 * не унесли дальше копированием ссылки.
 */
export const INTERNAL_KEY = 'bb.analytics.internal';

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null;
type Place = { readonly href: string };
type History = { replaceState(data: unknown, unused: string, url?: string | URL | null): void; readonly state: unknown };

export function internalBrowser(location: Place, store: Store, history: History | null): boolean {
  let url: URL | null = null;
  try { url = new URL(location.href); } catch { /* адрес без разбора — отметка только из памяти */ }
  const asked = url?.searchParams.get('bb_internal') ?? null;
  if (url && asked !== null) {
    try {
      if (asked === '1') store?.setItem(INTERNAL_KEY, '1');
      else if (asked === '0') store?.removeItem(INTERNAL_KEY);
    } catch { /* без памяти браузера отметка действует только на эту загрузку */ }
    url.searchParams.delete('bb_internal');
    try { history?.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch { /* адрес останется с меткой */ }
  }
  try { return store?.getItem(INTERNAL_KEY) === '1' || asked === '1'; } catch { return asked === '1'; }
}
